//
function searchProducts(query) {
  let url = `/search?q=${query}&type=product`;
  let loader = document.querySelector(".search-product-loader");
  loader.classList.add("active");
  fetch(url)
    .then((res) => res.text())
    .then((text) => {
      let parser = new DOMParser();
      let html = parser.parseFromString(text, "text/html");
      let searchProducts = html.querySelector(".search-product-grid");
      let statusText = html.querySelector(".status-text");
      let paginate = html.querySelector(".search-paginate");
      searchProducts
        ? (document.querySelector(".search-product-grid").innerHTML =
            searchProducts.innerHTML)
        : "";
      statusText
        ? (document.querySelector(".status-text").innerHTML =
            statusText.innerHTML)
        : "";
      paginate
        ? (document.querySelector(".search-paginate").innerHTML =
            paginate.innerHTML)
        : "";
      window.history.pushState({}, "", `/search?q=${query}&type=product`);
    })
    .catch((err) => console.log(err));
}
function handleSearchFormSubmission(e) {
  e.preventDefault();
  let queryValue = e.target.querySelector(".search-input").value;
  searchProducts(queryValue);
}
document
  .querySelector("form[action='/search']")
  .addEventListener("submit", handleSearchFormSubmission);
